import { action, makeObservable, observable, runInAction } from 'mobx'

import { getOrdersCount } from 'shared/api/orders'

import { RetailerSubscription, RetailerItemsCount } from 'retailer/stores'

class MainMenuStore {
  @observable open = false
  @observable ordersCount = 0
  @observable retailerItemsCount = new RetailerItemsCount()
  @observable retailerSubscription

  @action.bound
  fetchRetailerSubscription () {
    const retailerSubscription = new RetailerSubscription()
    return retailerSubscription.fetch()
      .then(action(() => {
        this.retailerSubscription = retailerSubscription
        return retailerSubscription
      }))
      .catch(error => {
        console.error('Unable to fetch retailer subscription details.', error)
        return null
      })
  }

  constructor () {
    makeObservable(this)
  }

  @action.bound
  fetchOrdersCount () {
    getOrdersCount().then(response => {
      runInAction(() => {
        this.ordersCount = response.data.count
      })
    })
  }

  @action.bound
  toggle () {
    this.open = !this.open
  }
}

export default MainMenuStore
